import { useEffect } from 'react';

export default function SEO({ title, description, canonical }) {
  useEffect(() => {
    // Page title logic matching prompt rules:
    // Forside: "Lunde Media"
    // Undersider: "[Titel på underside] - Lunde Media"
    let finalTitle = 'Lunde Media';
    if (title && title !== 'Forside' && title !== 'Lunde Media') {
      finalTitle = title.includes('Lunde Media') ? title : `${title} - Lunde Media`;
    }
    document.title = finalTitle;

    // Meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    const defaultDesc =
      'Lunde Media v/ Michael – Professionel fotograf og videograf med fokus på storytelling, følelser, nærvær og ægte øjeblikke inden for bryllupper, sport, events og familier.';
    const finalDesc = description || defaultDesc;

    if (metaDesc) {
      metaDesc.setAttribute('content', finalDesc);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = finalDesc;
      document.head.appendChild(meta);
    }

    // Open Graph
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', finalTitle);

    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.setAttribute('content', finalDesc);

    // Canonical link
    if (canonical) {
      let linkCanonical = document.querySelector('link[rel="canonical"]');
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.setAttribute('rel', 'canonical');
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.setAttribute('href', canonical);
    }
  }, [title, description, canonical]);

  return null;
}
